import { render } from "./TitleVue.vue?vue&type=template&id=ec52c89a&scoped=true"
import script from "./TitleVue.vue?vue&type=script&lang=js"
export * from "./TitleVue.vue?vue&type=script&lang=js"

import "./TitleVue.vue?vue&type=style&index=0&id=ec52c89a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec52c89a"]])

export default __exports__